//Libraries
import { useLocation, useNavigate } from 'react-router';

// Illustrations
import { ReactComponent as BrokenLightBulb } from 'assets/images/errors/broken-lightbulb.svg';

//Components
import ErrorPage from 'components/ErrorPage';
import IntlMessages from 'components/util/IntlMessages';

//Constants
import { BASENAME_URL, BASENAME_URL_ADFS_TOKEN_EXPIRY } from 'constants/settings';

const Error404 = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // The identity provider's session ran out: the same page, with its own text.
    const isADFSFailure = location?.pathname === BASENAME_URL_ADFS_TOKEN_EXPIRY;

    return (
        <ErrorPage
            illustration={<BrokenLightBulb />}
            title={<IntlMessages id={isADFSFailure ? 'page.404.description.adfs' : 'page.404.description.part1'} />}
            description={!isADFSFailure && <IntlMessages id="page.404.description.part2" />}
            buttonLabel={<IntlMessages id={isADFSFailure ? 'page.401.adfs.button' : 'page.404.button'} />}
            onButtonClick={() => navigate(BASENAME_URL)}
        />
    );
};

export default Error404;
